import React, { Component } from "react";
import Slider from "react-slick";
import miami from '../assets/images/miami.png'
import toronto from '../assets/images/toronto.png'
import jerseyCity from '../assets/images/ijerseyCity.png'
import atlanta from '../assets/images/atlanta.png'
import pheonix from '../assets/images/pheonix.png'
import lasvegas from '../assets/images/lasVegas.png'
import Dallas from '../assets/images/dallas.png'
import wasington from '../assets/images/washingotn.png'
export default class SwipeToSlid extends Component {
  render() {
    const settings = {
      dots:'false',
      infinite: true,
      slidesToShow: 6,
      slidesToScroll:1,
      initialSlide:1,
      responsive:[
        {
        breakpoint:1024,
        settings:{
          slidesToShow:5,
          slidesToScroll:1,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:600,
        settings:{
          slidesToShow:4,
          slidesToScroll:1,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:480,
        settings:{
          slidesToShow:2,
          slidesToScroll:1,
          infinite:true,
          dots:false
        }
      },
      {
        breakpoint:320,
        settings:{
          slidesToShow:1,
          slidesToScroll:1,
          infinite:true,
          dots:false
        }

      }

    ]
    
    };
    return (
      <div className="slider3-child">
        <h2>Browse by destination</h2>
        <Slider {...settings}>
          <div >
            <div className="cards-slider3">
            {/* <div> */}
            <img src={miami}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p  className='countryName'style={{textAlign:'center',fontWeight:'bold'}}>Toyota</p>
            {/* </div> */}
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={toronto}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>Lamborghini</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={wasington}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>Ford</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={Dallas}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>tesla</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={lasvegas}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>porsche</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={jerseyCity}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>bmw</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={atlanta}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>subaru</p>
            </div>
            </div>
          </div>
          <div>
          <div className="cards-slider3">
          <div>
            <img src={pheonix}  style={{width:'120px',height:'120px',borderTopLeftRadius:'8px',
            borderTopRightRadius:'8px',color:'black'}}></img>
            <p className='carsBrandName' style={{textAlign:'center',fontWeight:'bold'}}>nissan</p>
            </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}